import React from 'react';
import images from '../../assets/images';

export const Loading = () => {
    return <div className="loading-tp"><img src={images.tp} alt="loading" />Loading...</div>
}